import {
  faBug,
  faFile,
  faInfoCircle,
  faList,
  faQuestionCircle,
  faQuoteLeft,
} from '@fortawesome/pro-solid-svg-icons';
import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import {
  BLOG_SPORT,
  GAME_RULES,
  HELP,
  LEGAL_NOTICE,
  TERMS_AND_CONDITIONS,
} from 'constants/__generated__/routes';
import { useSportContext } from 'contexts/sport';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { useIsMobileApp } from 'hooks/useIsMobileApp';
import { navLabels } from 'lib/glossary';
import { sportToBlogSportMap } from 'lib/routing';

import { Footer } from './Footer';
import { NavItem, Separator } from '../../../NavItem';

const Root = styled(Vertical).attrs({ gap: 0.5 })`
  border-radius: var(--intermediate-unit);
  background-color: var(--c-black);
`;
const SeparatorWrapper = styled(Horizontal)`
  width: 100%;
  padding: var(--unit) var(--unit) var(--half-unit) var(--unit);
`;

type Props = { onClick?: () => void; noFooter?: boolean };
export const MoreNavItems = ({ onClick, noFooter }: Props) => {
  const { formatMessage } = useIntl();
  const { isAndroidApp, postMessage } = useIsMobileApp();
  const {
    flags: { isSorareInternal = false },
  } = useFeatureFlags();
  const { sport: currentSport } = useSportContext();

  return (
    <Root onClick={onClick}>
      {!!isAndroidApp && !!isSorareInternal && (
        <NavItem
          icon={() => <FontAwesomeIcon icon={faBug} />}
          label={formatMessage(navLabels.mobileDebugScreen)}
          onClick={() => {
            postMessage('debugScreen', {});
          }}
        />
      )}
      <NavItem
        icon={() => <FontAwesomeIcon icon={faQuoteLeft} />}
        label={formatMessage(navLabels.blog)}
        to={generatePath(BLOG_SPORT, {
          sport: sportToBlogSportMap[currentSport],
        })}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={faQuestionCircle} />}
        label={formatMessage(navLabels.help)}
        to={HELP}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={faInfoCircle} />}
        label={formatMessage(navLabels.gameRules)}
        to={GAME_RULES}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={faList} />}
        label={formatMessage(navLabels.terms)}
        to={TERMS_AND_CONDITIONS}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={faFile} />}
        label={formatMessage(navLabels.legalNotice)}
        to={LEGAL_NOTICE}
      />
      {!noFooter && (
        <>
          <SeparatorWrapper>
            <Separator />
          </SeparatorWrapper>
          <Footer copyrightWrapped />
        </>
      )}
    </Root>
  );
};
